import * as React from "react";

const Measure: React.FC = () => {
    return <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 16 14" enableBackground="new 0 0 16 14" xmlSpace="preserve">
<path fillRule="evenodd" clipRule="evenodd" fill="#FAAB19" d="M15.5,0.5v13h-15v-13H15.5z"/>
<path d="M0,0v14h16V0H0z M15,13H1V1h2v4h1V1h2v6h1V1h2v4h1V1h2v6h1V1h2V13z"/>
</svg>
;
};

export default React.memo(Measure);
